import React from 'react';

const h = React.createElement;

/**
 * Hatched loading placeholder.
 *
 * @param {object} p
 * @param {number|string} [p.w]
 * @param {number} [p.h]
 * @param {number} [p.r]
 * @param {React.CSSProperties} [p.style]
 */
export function Skeleton({ w = '100%', h: hh = 12, r = 6, style }) {
  return h('div', { 'aria-hidden': true, className: 'gx-march', style: { width: w, height: hh, borderRadius: r, background: 'repeating-linear-gradient(135deg, var(--track) 0 6px, var(--inset) 6px 12px)', backgroundSize: '17px 17px', border: '1.5px solid var(--line2)', boxSizing: 'border-box', ...style } });
}
